import { render, staticRenderFns } from "./FieldsetRentalValidityData.yaml?vue&type=template&id=3c65a202&component"
import script from "./FieldsetRentalValidityData.yaml?vue&type=script&lang=ts&component"
export * from "./FieldsetRentalValidityData.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports